function initProductMediaSwiper() {
  const container = document.querySelector('#product-media-container');
  if (!container) return;

  const slides = container.querySelectorAll('.swiper-slide');
  if (slides.length <= 1) return;

  const desktopQuery = window.matchMedia('(min-width: 820px)');
  let swiperInstance = null;

  function renderBullet(index, className) {
    return `<span class="${className}" aria-label="Go to media ${index + 1}">
    <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.41964 0.0892327C5.35779 0.203798 5.20822 0.257553 5.08704 0.208572C4.74865 0.0713836 3.7852 1.73342 3.43235 3.06296C3.13392 4.18765 3.07478 4.26652 2.36382 4.48735C1.18207 4.85429 0.616522 5.12431 0.616522 5.3221C0.616522 5.42255 0.503846 5.50454 0.366392 5.50454C0.228756 5.50454 0.0712265 5.7017 0.0162448 5.94246C-0.119763 6.53998 0.623757 7.37245 1.29348 7.37245C2.74869 7.37245 3.86478 8.63994 3.86931 10.2978C3.87726 13.1429 6.18559 12.1778 6.48799 9.20301C6.63395 7.76762 6.71208 7.68958 8.30781 7.38532C10.022 7.05864 10.1322 6.96442 9.92073 6.00618C9.70894 5.0471 9.06688 4.47946 7.91751 4.2356C6.81462 4.00148 6.58493 3.64782 6.58493 2.18379C6.58493 1.04623 6.44639 0.669948 5.83237 0.139874C5.63885 -0.0272008 5.49199 -0.0452574 5.41964 0.0892327Z" fill="currentColor"/>
    </svg>
    </span>`;
  }

  function buildConfig() {
    const config = {
      speed: 400,
      slidesPerView: 1,
      spaceBetween: 0,
      direction: 'horizontal',
      cssMode: false,
      freeMode: false,
      mousewheel: false,
      keyboard: false,
      pagination: {
        el: '#product-media-container .swiper-pagination',
        clickable: true,
        renderBullet: renderBullet
      }
    };

    if (desktopQuery.matches) {
      config.slidesPerView = 'auto';
      config.spaceBetween = 16;
      config.direction = 'vertical';
      config.cssMode = false;
      config.freeMode = true;
      config.mousewheel = true;
      config.keyboard = true;
    }

    return config;
  }

  function mountSwiper() {
    if (swiperInstance) swiperInstance.destroy(true, true);
    swiperInstance = new Swiper('#product-media-container', buildConfig());
  }

  mountSwiper();
  desktopQuery.addEventListener('change', mountSwiper);
}

function initProductInfoTabs() {
  const tabsContainer = document.querySelector('[data-product-info-tabs]');
  if (!tabsContainer) return;

  const tabButtons = Array.from(tabsContainer.querySelectorAll('[data-tab-button]'));
  const tabPanels = Array.from(tabsContainer.querySelectorAll('[data-tab-panel]'));
  const panelsContainer = tabsContainer.querySelector('[data-tab-panels]');
  if (!tabButtons.length || !tabPanels.length) return;

  const lockPanelsHeight = function () {
    if (!panelsContainer) return;

    let maxPanelHeight = 0;

    tabPanels.forEach(function (panel) {
      const wasHidden = panel.hidden;
      const previousPosition = panel.style.position;
      const previousVisibility = panel.style.visibility;
      const previousDisplay = panel.style.display;

      if (wasHidden) {
        panel.hidden = false;
      }

      panel.style.position = 'absolute';
      panel.style.visibility = 'hidden';
      panel.style.display = 'block';

      maxPanelHeight = Math.max(maxPanelHeight, panel.offsetHeight);

      panel.style.position = previousPosition;
      panel.style.visibility = previousVisibility;
      panel.style.display = previousDisplay;

      if (wasHidden) {
        panel.hidden = true;
      }
    });

    panelsContainer.style.minHeight = maxPanelHeight + 'px';
  };

  const activateTab = function (tabKey) {
    tabButtons.forEach(function (button) {
      const isActive = button.getAttribute('data-tab-button') === tabKey;
      button.classList.toggle('active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      button.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    tabPanels.forEach(function (panel) {
      const isActive = panel.getAttribute('data-tab-panel') === tabKey;
      panel.hidden = !isActive;
    });
  };

  tabButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      activateTab(button.getAttribute('data-tab-button'));
    });
  });

  lockPanelsHeight();
  window.addEventListener('resize', lockPanelsHeight);
}

function initProductFamilyColorPreview() {
  const familyOption = document.querySelector('[data-product-family-color]');
  if (!familyOption) return;

  const currentLabel = familyOption.querySelector('[data-product-family-color-current]');
  if (!currentLabel) return;

  const defaultColor = currentLabel.getAttribute('data-default-family-color') || '';
  const familyLinks = Array.from(familyOption.querySelectorAll('[data-family-color]'));
  if (!familyLinks.length) return;

  const setCurrentColor = function (colorName) {
    currentLabel.textContent = colorName;
  };

  const restoreDefaultColor = function () {
    setCurrentColor(defaultColor);
  };

  const previewLinkColor = function (link) {
    const colorName = link.getAttribute('data-family-color');
    if (!colorName) return;
    setCurrentColor(colorName);
  };

  familyLinks.forEach(function (link) {
    link.addEventListener('mouseenter', function () {
      previewLinkColor(link);
    });

    link.addEventListener('focus', function () {
      previewLinkColor(link);
    });

    link.addEventListener('click', function (event) {
      if (link.classList.contains('active')) {
        event.preventDefault();
      }
    });
  });

  familyOption.addEventListener('mouseleave', restoreDefaultColor);

  familyOption.addEventListener('focusout', function (event) {
    if (familyOption.contains(event.relatedTarget)) return;
    restoreDefaultColor();
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initProductMediaSwiper();
  initProductInfoTabs();
  initProductFamilyColorPreview();
});